import React, { useState, useEffect } from 'react';
import { api } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Loader2, Flag } from 'lucide-react';
import { toast } from 'sonner';

function AdminComplaintsPanel({ onRefresh }) {
  var complaintsState = useState([]);
  var loadingState = useState(true);
  
  useEffect(function() {
    loadingState[1](true);
    api.getAdminComplaints({ page: 1 }).then(function(res) {
      complaintsState[1](res.data.complaints || []);
    }).catch(function() {
      toast.error('Failed');
    }).finally(function() {
      loadingState[1](false);
    });
  }, []);

  var complaints = complaintsState[0];
  var loading = loadingState[0];

  return (
    <Card className="card-base">
      <CardHeader>
        <CardTitle className="text-white">Complaints</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <Loader2 className="h-6 w-6 animate-spin mx-auto text-teal-400" />
        ) : complaints.length === 0 ? (
          <p className="text-slate-400 text-center py-4">No complaints</p>
        ) : (
          <div className="space-y-2">
            {complaints.map(function(c) {
              return (
                <div key={c.id} className="p-3 rounded bg-slate-800/50">
                  <p className="text-white">{c.category_label}</p>
                  <p className="text-sm text-slate-400">{c.status}</p>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default AdminComplaintsPanel;
